/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_When_LabelInputs */

const th_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมื่อไร`)
};

const en_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When?`)
};

const ja_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いつ`)
};

const zh_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么时候？`)
};

const es_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuándo?`)
};

const pt_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando?`)
};

const id_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapan?`)
};

const fr_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand ?`)
};

const tl_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kailan?`)
};

const vi_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khi nào?`)
};

const ko_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`언제인가요?`)
};

const de_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann?`)
};

const ru_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Когда?`)
};

const tr_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne zaman?`)
};

const it_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando?`)
};

const pl_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiedy?`)
};

const uk_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Коли?`)
};

const hi_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कब?`)
};

const ar_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متى؟`)
};

const ms_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bila?`)
};

const bn_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কখন?`)
};

const zh_tw2_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什麼時候？`)
};

const zh_hk2_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什麼時候？`)
};

const ur_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کب؟`)
};

const fa_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چه زمانی؟`)
};

const sw_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lini?`)
};

const nl_meeting_when_label = /** @type {(inputs: Meeting_When_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wanneer?`)
};

/**
* | output |
* | --- |
* | "When?" |
*
* @param {Meeting_When_LabelInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_when_label = /** @type {((inputs?: Meeting_When_LabelInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_When_LabelInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_when_label(inputs)
	if (locale === "ja") return ja_meeting_when_label(inputs)
	if (locale === "zh") return zh_meeting_when_label(inputs)
	if (locale === "es") return es_meeting_when_label(inputs)
	if (locale === "pt") return pt_meeting_when_label(inputs)
	if (locale === "id") return id_meeting_when_label(inputs)
	if (locale === "fr") return fr_meeting_when_label(inputs)
	if (locale === "tl") return tl_meeting_when_label(inputs)
	if (locale === "vi") return vi_meeting_when_label(inputs)
	if (locale === "ko") return ko_meeting_when_label(inputs)
	if (locale === "de") return de_meeting_when_label(inputs)
	if (locale === "ru") return ru_meeting_when_label(inputs)
	if (locale === "tr") return tr_meeting_when_label(inputs)
	if (locale === "it") return it_meeting_when_label(inputs)
	if (locale === "pl") return pl_meeting_when_label(inputs)
	if (locale === "uk") return uk_meeting_when_label(inputs)
	if (locale === "hi") return hi_meeting_when_label(inputs)
	if (locale === "ar") return ar_meeting_when_label(inputs)
	if (locale === "ms") return ms_meeting_when_label(inputs)
	if (locale === "bn") return bn_meeting_when_label(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_when_label(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_when_label(inputs)
	if (locale === "ur") return ur_meeting_when_label(inputs)
	if (locale === "fa") return fa_meeting_when_label(inputs)
	if (locale === "sw") return sw_meeting_when_label(inputs)
	if (locale === "nl") return nl_meeting_when_label(inputs)
	return en_meeting_when_label(inputs)
});